/* eslint-disable quotes */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';
import Modal from '../common/Modal';
import { firstPlaceTrophy, secondPlaceTrophy, thirdPlaceTrophy } from './util/getTrophyImage';

export class PrizeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fadeModalOut: false,
      // for testing images in modal
      // PrizeImageArray: [{prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}, { prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}, { prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}],
      // PrizeImageArray: [{prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}, { prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}],
      // PrizeImageArray: [{prizeImageFilename:'20201020231224_att-hbo-promo (1).png'}],
      // PrizeImageArray: [],
    }
  }

  componentDidUpdate = (prevProps) => {
    const { 
      props: {
        contests,
        contests: { contestEventResults },
        contestEventId,
        actions: { fetchPrizeImage }
      }
    } = this;

    const contestPrizePayouts = contests['contestEventPrizePayouts-'+contestEventId];
    const prevContestPrizePayouts = prevProps.contests['contestEventPrizePayouts-'+contestEventId];
    const contestResults = contestEventResults['contestEventResults-'+contestEventId];
    const { prizeImage1, prizeImage2, prizeImage3 } = contestResults;
    const prevContestResults = prevProps.contests.contestEventResults['contestEventResults-'+contestEventId];

    if(contestPrizePayouts && prevContestPrizePayouts !== contestPrizePayouts && contestPrizePayouts.length > 0) {
      contestPrizePayouts.map((ele, index) => {
        const { prizeImageFilename, prizeName } = ele;
        
        if(prizeImageFilename && prizeImageFilename.length > 0) {
          fetchPrizeImage(prizeImageFilename, {index: index+1, contestEventId })
        }
        
        if(prizeName) this.setState({ ['prizeName'+[index+1]]: prizeName })
        
        return ele
      })
      
      this.setState({ contestPrizePayouts })
    }

    if(contestResults && prizeImage1 !== prevContestResults.prizeImage1 && !this.state.hasImage1) {
      this.setState({ prizeImage1, hasImage1: true })
    }

    if(contestResults && prizeImage2 !== prevContestResults.prizeImage2 && !this.state.hasImage2) {
      this.setState({ prizeImage2, hasImage2: true })
    }

    if(contestResults && prizeImage3 !== prevContestResults.prizeImage3 && !this.state.hasImage3) {
      this.setState({ prizeImage3, hasImage3: true })
    }
  }

  toggleModal = () => {
    // sets fadeModalOut flag to true. Common Modal will detect prevProp change and will fade out modal
    this.timeout = setTimeout(() => {
      this.props.closeModal()
    }, 250);
  }

  render() {
    const {
      props: { contestEndTime },
      state: { prizeImage1, prizeImage2, prizeImage3, prizeName1, prizeName2, prizeName3, contestPrizePayouts, hasImage1, hasImage2, hasImage3 } 
    } = this;
    let allImagesAvailable = false;

    if(contestPrizePayouts) {
      if(contestPrizePayouts.length > 2) {
        allImagesAvailable = hasImage1 && hasImage2 && hasImage3;
      } else if(contestPrizePayouts.length === 2) {
        allImagesAvailable = hasImage1 && hasImage2;
      } else if(contestPrizePayouts.length === 1) {
        allImagesAvailable = hasImage1;
      } else if(contestPrizePayouts.length === 0) {
        allImagesAvailable = true;
      }
    }

    return (
      <div>
        <Modal
          domQuery="body"
          toggleModal={this.props.closeModal}
          fadeCFModal={ this.props.fadeCFModal }
        >
          <div className={`PrizeModal`}>
            <div className="PrizeModal__hdr">
              Prize Awards
            </div>
            { allImagesAvailable || !contestPrizePayouts ?
              <div className="PrizeModal__body">
                <div className="PrizeModal__body-title">
                  Individual Top Performers
                </div>
                <div className="PrizeModal__body-subtitle">
                  Ends { contestEndTime.split(' ')[0] }
                </div>
                <div className={`PrizeModal__body-wrap${prizeImage3 !== undefined ? '--column' : '' }`}>
                  <div className={`PrizeModal__prize-wrap${!prizeImage2 ? '--margin' : '' }`}>
                    { firstPlaceTrophy() }
                    <div className="PrizeModal__prize-place">
                      1st Place Prize
                    </div>
                    { prizeImage1 ?
                      <img src={ prizeImage1 } alt="" className="PrizeModal__image"/>
                      :
                      <div>{ prizeName1 ? prizeName1 : 'N/A'}</div>
                    }
                  </div>
                  { prizeImage2 !== undefined &&
                    <div className={`PrizeModal__bottom-wrap${prizeImage3 !== undefined ? '--margin' : '' }`}>
                        <div className='PrizeModal__prize-wrap'>
                        { secondPlaceTrophy() }
                          <div className="PrizeModal__prize-place">
                            2nd Place Prize
                          </div>
                          { prizeImage2 ?
                            <img src={ prizeImage2 } alt="" className="PrizeModal__image"/>
                            :
                            <div>{ prizeName2 ? prizeName2 : 'N/A'}</div>
                          }
                        </div>
                      
                      { prizeImage3 !== undefined &&
                        <div className='PrizeModal__prize-wrap'>
                          { thirdPlaceTrophy() }
                          <div className="PrizeModal__prize-place">
                            3rd Place Prize
                          </div>
                          { prizeImage3 ?
                            <img src={ prizeImage3 } alt="" className="PrizeModal__image"/>
                            :
                            <div>{ prizeName3 ? prizeName3 : 'N/A'}</div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              :
              <div className='PrizeModal__loader'>
                <div className='PrizeModal__loader-bars'>
                  <span></span><span></span><span></span><span></span><span></span>
                </div>
                <h6 className='PrizeModal__loader-text'>Loading Prize Awards...</h6>
              </div>
            }
            <div className="PrizeModal__ftr">
              <div className="PrizeModal__ftr-btn-wrap">
                <button
                  onClick={ this.props.closeModal }
                  className="PrizeModal__cancel"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = ({ contests }) => ({ contests })
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...actions }, dispatch)});

export default connect(mapStateToProps, mapDispatchToProps)(PrizeModal);



// WEBPACK FOOTER //
// ./src/features/contests/PrizeModal.js